import React from 'react';
import Card from './card';
import type { PlusProject } from '../../../models/plus/plusProject';

interface Props {
  projects: PlusProject[];
}

const ANGEL_TAX_NOTE =
  '本案件の発行者については、エンジェル税制の対象企業に関する要件の確認が行われています（都道府県の確認が未了の場合があります）。この確認は発行者（会社）側の要件に関するものであり、お客様が優遇措置を受けられることを示すものではありません。優遇措置を受けるには、払込み後の所定の手続（事後申請等）と都道府県知事の確認を経て、取得した株式を取得年の12月31日まで保有すること等が必要で、適用の可否はお客様の状況により異なります。認定は都道府県が行い、当社が適用を保証するものではありません。詳細は所轄税務署・税理士等にご確認ください。';

export default function IndexView({ projects }: Props) {
  return (
    <div className="plus-projects-index">
      <h1 className="plus-projects-index__title">投資案件一覧</h1>
      {projects.length === 0 ? (
        <p className="plus-projects-index__empty">
          現在閲覧可能な案件はありません。
        </p>
      ) : (
        <>
          <div className="plus-projects-index__list">
            {projects.map(project => (
              <Card key={project.id} project={project} />
            ))}
          </div>
          <p className="plus-projects-index__angel-note">{ANGEL_TAX_NOTE}</p>
        </>
      )}
    </div>
  );
}
